import axios from 'axios';
import { devEnv, RISK_PROFILE_API_URL } from 'services/constants';

const axiosInstance = axios.create({ withCredentials: devEnv });

/**
 * Fetch sanction info for a partner
 */
export const getSanctionInfo = async (partnerId: string) => {
  const response = await axiosInstance.get(`${RISK_PROFILE_API_URL}/api/v1/partners/${partnerId}/sanction-info`);
  return response.data;
};
